var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SdsButtonText',{attrs:{"variant":_vm.buttonVariant,"iconName":_vm.iconName},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.item.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }